import { render, staticRenderFns } from "./PlayerMainControls.vue?vue&type=template&id=69bb9006&scoped=true&"
import script from "./PlayerMainControls.vue?vue&type=script&lang=js&"
export * from "./PlayerMainControls.vue?vue&type=script&lang=js&"
import style0 from "./PlayerMainControls.vue?vue&type=style&index=0&id=69bb9006&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69bb9006",
  null
  
)

component.options.__file = "PlayerMainControls.vue"
export default component.exports